import { AODA } from '@core/utilities/aoda';
import { Component, ElementRef, Injector, Input, OnDestroy, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '@shared/components/base.component';
import { ActivatedRoute } from '@angular/router';
import { DrillHole } from '@shared/models/records/drill-hole.model';
import { environment } from '@environments/environment';
import { DatabaseIndexNameType } from '@shared/models/common/database-index-name.model';

@Component({
  selector: 'app-drill-hole-result-card',
  templateUrl: './drill-hole-result-card.component.html',
  styleUrls: ['./drill-hole-result-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class DrillHoleResultCardComponent extends BaseComponent implements OnInit, OnDestroy {

    @Input() record: any;
    @Input() searchTerm: string;
    searchTerms: string;
    isSingleClick: Boolean = true;     

    constructor(
        private injector: Injector,
        private route: ActivatedRoute,
        private el: ElementRef,
        private r2: Renderer2) {
        super(injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.record = new DrillHole(this.record._source);
        this.searchTerms = this.searchTerm;
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    ngAfterViewInit(): void {
        AODA.applyAllFixes(this.el, this.r2, this.languageService.languageType);
    }

    get company_hole_id(): string {
        return this.record.company_hole_id;
    }

    get company_name() {
        return this.record.company_name;
    }

    get associatedAssessmentFile() {
        return this.record.tech_id;
    }

    get township(): string {
        return this.record.township;
    }

    get year_drilled() {
        return this.record.year_drilled;
    }

    openInSameTab() {
        this.isSingleClick = true;
        setTimeout(()=>{
            if(this.isSingleClick){
                this.router.navigate(['/drill-hole', this.associatedAssessmentFile, this.company_hole_id], { state: { data: this.record, searchTerms: this.searchTerms} });
            }
        }, 250)
    }

    openInNewTab() {
        this.isSingleClick = false;
        var target = environment.application_url + "persistent-linking?" + DatabaseIndexNameType.drillHoles + "=" + this.associatedAssessmentFile;
        this.router.navigate([], { state: { data: this.record, searchTerms: this.searchTerms} }).then(() => {  window.open(target, '_blank'); });
     }

}
